import { useContext, useEffect, useState } from "react";
import { GenerateDashboardStateId } from "../../../../functions/GenerateDashboardStateId";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../AppProvider";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/NewDashboardState.css";

const NewDashboardState = ({showNewDashboardStateWindow,setShowNewDashboardStateWindow,dashboardStates,setDashboardStates}) =>{
    const {user} = useContext(AppContext);
    const { tenantId, dashboardId } = useParams();
    const [dashboardStateName,setDashboardStateName] = useState('');
    const [dashboardStateId,setDashboardStateId] = useState('');
    const [isRootState,setIsRootState] = useState(false);
    const [showTitle,setShowTitle] = useState(true);
    const discardNewDashboardState = () =>{
        setDashboardStateName('');
        setDashboardStateId('');
        setIsRootState(false);
        setShowTitle(true);
        setShowNewDashboardStateWindow(false);
    };
    const addNewDashboardState = () =>{
        setDashboardStates(prev => {
            const updatedStates = isRootState? prev.map(state => ({...state,rootState:false})):prev;
            const newDashboardState = {
                id:dashboardStateId,
                dashboardId:dashboardId,
                name:dashboardStateName,
                rootState:isRootState,
                showTitle:showTitle
            };
            return [...updatedStates,newDashboardState];
        });
        discardNewDashboardState();
    };
    useEffect(() =>{
        if(!showNewDashboardStateWindow) return;
        const generateUniqueId = async() =>{
            if(!dashboardStates){
                setShowNewDashboardStateWindow(false);
                return;
            }
            let tries = 0;
            let newDashboardStateId = await GenerateDashboardStateId(tenantId,dashboardId,user?.access_token);
            const existingIds = dashboardStates?.map(state => state?.id);
            while((newDashboardStateId == null || existingIds?.includes(newDashboardStateId)) && tries < 100){
                newDashboardStateId = await GenerateDashboardStateId(tenantId,dashboardId,user?.access_token);
                tries++;
            }
            if(newDashboardStateId === null || existingIds.includes(newDashboardStateId)){
                setShowNewDashboardStateWindow(false);
                return;
            }
            setDashboardStateId(newDashboardStateId);
        };
        generateUniqueId();
    },[showNewDashboardStateWindow]);
    if(!showNewDashboardStateWindow) return null;
    return(
        <div className="new-dashboard-state-parent-container">
            <div className="new-dashboard-state-container">
                <div className="new-dashboard-state-header">
                    <h3>Add dashboard state</h3>
                    <p onClick={() => discardNewDashboardState()}>&#10006;</p>
                </div>
                <div className="new-dashboard-state-body">
                    <div className="new-dashboard-state-entry-container">
                        <p>Name<span>*</span></p>
                        <input
                            value={dashboardStateName}
                            onChange={(e) => setDashboardStateName(e.target.value)}
                        />
                    </div>
                    <div className="new-dashboard-state-entry-container">
                        <p>State Id<span>*</span></p>
                        <input readOnly value={dashboardStateId}/>
                    </div>
                    <div className="new-dashboard-state-checkboxes-container">
                        <label>
                            <input
                                type="checkbox"
                                checked={isRootState}
                                onChange={(e) => setIsRootState(e.target.checked)}
                            />
                            <span>Root state</span>
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showTitle}
                                onChange={(e) => setShowTitle(e.target.checked)}
                            />
                            <span>Show title</span>
                        </label>
                    </div>
                </div>
                <div className="new-dashboard-state-buttons-container">
                    <button className="cancel-button" onClick={() => discardNewDashboardState()}>
                        Cancel
                    </button>
                    <button className={`add-button ${!dashboardStateName || dashboardStateName === ''? 'inactive':'active'}`}
                        onClick={() =>{
                            if(dashboardStateName && dashboardStateName !== '') addNewDashboardState();
                        }}>
                        Add
                    </button>
                </div>
            </div>
        </div>
    );
};
export default NewDashboardState;